import { MenuType } from 'api/models';
import { TXT_BREAKFAST, TXT_DINNER } from 'translations';

export const getMenuTypeText = (menuType: MenuType) => {
  switch (menuType) {
    case MenuType.Breakfast:
      return TXT_BREAKFAST;
    case MenuType.Dinner:
      return TXT_DINNER;
    default:
      return '';
  }
};
